import globaltypes from '../globaltypes'
import types from './types'
import { sortBy, uniq, cloneDeep, flatten, includes, zipObject } from 'lodash'
import config from '../../config'

export default {
  [types.getters.crop]: (state) => (title) => {
    const crop = state.crops.find(c => c.post_title.toLowerCase() === title.toLowerCase())
    return (cloneDeep(crop) || null)
  },
  [types.getters.cropById]: (state) => (id) => {
    const crop = state.crops.find(c => c.key === id)
    return (cloneDeep(crop) || null)
  },
  [types.getters.translatedCropById]: (state, getters, rootState, rootGetters) => (id) => {
    const translatedID = rootGetters[globaltypes.i18n.getters.translatePostID](id)
    const crop = state.crops.find(c => c.key === translatedID)
    return (cloneDeep(crop) || null)
  },
  [types.getters.multiLanguageCropById]: (state) => (id) => {
    const crops = state.crops.filter(c => includes(c.postIDs, id))
    return zipObject(crops.map(c => c.languageCode), crops)
  },
  [types.getters.crops]: (state, getters, rootState, rootGetters) => {
    const locale = rootGetters[globaltypes.i18n.getters.postIDLocale]
    const filteredCrops = state.crops.filter(c => {
      if (locale(c.key) === rootState.user.locale) return true
      return config.allowUntranslatedCrops ? !locale(c.key) : false
    })
    return sortBy(cloneDeep(filteredCrops), crop => crop.post_title)
  },
  [types.getters.cropgroups]: (state, getters) => uniq(flatten(getters[types.getters.crops].map(c => c['crop_group']))).sort(),
  [types.getters.filter]: (state) => state.filter,
  [types.getters.filteredCrops]: (state, getters) => {
    var matchingCrops = []
    if (!state.filter) matchingCrops = getters[types.getters.crops]
    getters[types.getters.crops].forEach(crop => {
      if (crop['crop_group']) {
        crop['crop_group'].forEach(cg => {
          if (cg === state.filter) matchingCrops.push(crop)
        })
      }
    })
    return cloneDeep(sortBy(matchingCrops, crop => crop.post_title))
  }
}
